import { render, staticRenderFns } from "./policy-delete-modal.vue?vue&type=template&id=379f2a39"
import script from "./policy-delete-modal.vue?vue&type=script&lang=js"
export * from "./policy-delete-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports